module.exports = __webpack_public_path__ + "static/media/icon-park-solid_bank-card.b9eb9652.svg";